// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2M2Bh","name":"Header_name__3-J_P","birthday":"Header_birthday__FoofL","skeleton":"Header_skeleton__1iY6-"};